export const protocolData = [
  {
    key: 'Protocol',
    param: 'protocolNumber',
    value: ''
  },
  {
    key: 'LPO',
    param: 'leadGrp',
    value: ''
  },
  {
    key: 'Status',
    param: 'grpProtStatus,grpProtStatusDate',
    value: ''
  }
];

export const irbStatusData = [
  {
    key: 'Special Review',
    param: 'isSpecialReviewProtocol',
    value: ''
  },
  {
    key: 'CR Required?',
    param: 'isStatusCb',
    value: ''
  }];

export const siteData = [{
  key: 'Inst CTEP ID',
  param: 'InstCTEPId',
  value: ''
}];

export const irbExemptData = [{
  key: 'IRB Exempt',
  param: 'isIrbExempt',
  value: ''
}];